import request from '@/utils/request'

// 救援金规则
export function getRule(query) {
    return request({
        url: '/v1/jy/rule',
        method: 'get',
        params: query
    })
}

// 近期救援金记录
export function getTop(query) {
    return request({
        url: '/v1/jy/top',
        method: 'get',
        params: query
    })
}

// 救援金申请
export function getjy(query) {
    return request({
        url: '/v1/jy/get',
        method: 'get',
        params: query
    })
}



// 救援金进度查询
export function getHistory(query) {
    return request({
        url: `/v1/jy/history`,
        method: 'get',
        params: query
    })
}



export function getConfig(query) {
    return request({
        url: '/v1/packet/config',
        method: 'get',
        params: query
    })

}


//自助活动列表
export function getActs(query) {
    return request({
        url: '/v1/zz/acts',
        method: 'get',
        params: query
    })

}

//外链活动列表
export function getOutActs(query) {
    return request({
        url: '/v1/zz/out-acts',
        method: 'get',
        params: query
    })

}

//活动详情
export function getDetailZZ(id) {
    return request({
        url: '/v1/zz/detail?act_id=' + id,
        method: 'get',
    })
}



// 回归救援金申请
export function getzz(query) {
    return request({
        url: '/v1/zz/get',
        method: 'get',
        params: query
    })
}


// 救援金进度查询
export function getHistoryZZ(query) {
    return request({
        url: `/v1/zz/history`,
        method: 'get',
        params: query
    })
}

export function getPacket(query) {
    return request({
        url: '/v1/packet/get',
        method: 'get',
        params: query
    })
}




// 未登录
export function getInfo(query) {
    return request({
        url: '/v1/mem/get-info',
        method: 'get',
        params: query
    })
}



export function getjyinfo(query) {
    return request({
        url: '/v1/mem/get-jy-info',
        method: 'get',
        params: query
    })
}

export function gethbinfo(query) {
    return request({
        url: '/v1/mem/get-hb-info',
        method: 'get',
        params: query
    })
}


export function getzpinfo(query) {
    return request({
        url: '/v1/mem/get-zp-info',
        method: 'get',
        params: query
    })
}


export function getzp(query) {
    return request({
        url: '/v1/zp/get',
        method: 'get',
        params: query
    })
}



export function jyapply(query) {
    return request({
        url: '/v1/mem/jy-apply',
        method: 'get',
        params: query
    })
}

export function jycheck(query) {
    return request({
        url: '/v1/jy/check',
        method: 'get',
        params: query
    })
}


export function getHbHistory(query) {
    return request({
        url: `/v1/packet/history-with-details`,
        method: 'get',
        params: query
    })
}


export function getZpHistory(query) {
    return request({
        url: `/v1/zp/history-with-details`,
        method: 'get',
        params: query
    })
}